import { SavedAt } from '@/components/elements/saved-at/saved-at.component';
import { T } from '@/components/i18n/message.i18n.component';
import Button from '@/components/ui/button/button.component';
import { LifecycleStatus, Product } from '@/gql/graphql';
import { pretailoringPageMessages } from '@/pages/pre-tailoring/pre-tailoring.messages';

import InfoIcon from '@/assets/icons/info.svg?react';
import { cn } from '@/lib/utils';
import { useDialogStore } from '@/store/dialog.store';
import { ProductInfoModal } from './product-info-modal/product-info-modal.component';
import { tailoringHeadingMessages } from './tailoring-heading.messages';

type Props = {
  context: 'pre-tailoring' | 'tailoring';
  product?: Product;
};

export const TailoringHeading = ({ product, context }: Props) => {
  const { openDialog } = useDialogStore((state) => ({
    loading: state.loading,
    openDialog: state.openDialog,
    closeDialog: state.closeDialog,
    setDialogLoading: state.setLoading,
  }));

  const handleShowMoreInfo = () => {
    openDialog({
      type: 'custom',
      fullScreen: false,
      title: <T {...tailoringHeadingMessages.productInfoModalTitle} />,
      element: <ProductInfoModal product={product} context={context} />,
    });
  };

  return (
    <div className="flex flex-row justify-between mx-19 py-4 bg-white">
      <div className="flex flex-row items-center gap-x-4">
        <h1
          data-testid={`${context}-heading-product-name`}
          title={product?.name}
          className="mb-0 truncate max-w-[500px]"
        >
          {product?.name}
        </h1>
        <div
          data-testid={`${context}-heading-product-lifecycle-status`}
          className={cn(
            product?.lifecycleStatus == LifecycleStatus.Active && 'bg-product-status-active',
            product?.lifecycleStatus == LifecycleStatus.Retired && 'bg-product-status-retired',
            'text-product-status-text typo-smallest h-6 flex flex-row py-1 px-2 rounded',
          )}
        >
          {product?.lifecycleStatus}
        </div>
      </div>
      <div className="flex flex-row gap-x-3 items-center">
        <SavedAt data-testid={`${context}-heading-product-saved-at`} productId={product?.id || ''} />
        <Button data-testid={`${context}-heading-product-info-button`} onClick={handleShowMoreInfo} variant="secondary">
          <InfoIcon className="mr-2 text-primary" />
          <T {...pretailoringPageMessages.productInfoButton} />
        </Button>
      </div>
    </div>
  );
};
